@if (homePageContent()) {
  @let content = homePageContent();

  <div
    class="jumbotron"
    [style.backgroundImage]="`url('${content.hero_image.src}')`"
    [title]="content.hero_image.title ?? content.hero_image.alt_text"
  ></div>
  <div class="content-pane">
    <h1 class="title">{{ content.intro.title }}</h1>
    <div [innerHTML]="trustedDescription"></div>
    <div [ngClass]="getSubtoutsClass()">
      @for (section of content.sections; track section.name) {
        <app-home-tout
          [hero]="section.icon"
          [title]="section.title"
          [titleIcon]="section.icon"
          [link]="section.link_route"
          [linkText]="section.link_text"
          class="home-tout"
          ><div [innerHTML]="section.description"></div
        ></app-home-tout>
      }
    </div>
  </div>
}
